import { render, staticRenderFns } from "./MerchantBatchDia.vue?vue&type=template&id=810cfc0c&scoped=true"
import script from "./MerchantBatchDia.vue?vue&type=script&lang=js"
export * from "./MerchantBatchDia.vue?vue&type=script&lang=js"
import style0 from "./MerchantBatchDia.vue?vue&type=style&index=0&id=810cfc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810cfc0c",
  null
  
)

export default component.exports